module.exports = __webpack_public_path__ + "static/media/Wichita_(Park_City)_map.83890a27.png";